import { FEATURE_DARKEN_PAGE } from 'app/config/features';
import { StoreState } from 'app/models/types';
import { createSelector } from 'reselect';

export const optionsSelector = (state: StoreState) => state.general.options;
export const localeSelector = (state: StoreState) => state.general.options.locale;
export const serverSelector = (state: StoreState) => state.general.server;
export const featuresSelector = (state: StoreState) => state.general.features;

export const featureDarkenPageSelector = createSelector(
    featuresSelector,
    features => features[FEATURE_DARKEN_PAGE],
);

export const themeSelector = createSelector(
    optionsSelector,
    opts => opts.theme,
);

export const variantSelector = createSelector(
    optionsSelector,
    options => options.variant,
);
